// extracted by mini-css-extract-plugin
module.exports = {"search":"UserRelationshipPageView_search__2NHTr"};